<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" width="760" @close="close" @apply="save"
                        :title="form_title" :scrolled="false" :applyable="order.order_type !== 7">
    <div v-if="loading">
      <v-alert
          class="mt-4 rounded-lg"
          v-if="order.order_type === 4"
          type="warning"
          :icon="false"
          outlined
      >
        <b>Обратите внимание!</b>
        <p class="pa-0 ma-0">
          Время нахождения на территории – не более 4-х часов!
          Не ставить возле центрального входа и не загораживать места прохода.
        </p>
        <p class="pa-0 ma-0">
          По данному типу пропуска автомобиль может въехать на территорию только один раз.
          В случае необходимости повторного посещения, выберите тип пропуска "Временный автомобильный пропуск"
        </p>
      </v-alert>
      <v-alert
          class="mt-4 rounded-lg"
          v-if="order.order_type === 2 || order.order_type === 3 || order.order_type === 5"
          type="info"
          :icon="false"
          outlined
      >
        <b>Уважаемые пользователи!</b>
        <p class="pa-0 ma-0">
          Обращаем ваше внимание, что заявки рассматриваются в будние дни Пн-Чт с 9:00 до 18:00, Пт с 9:00 до 16:45
        </p>
      </v-alert>
      <!-- Блок типа заявки -->
      <v-autocomplete
          v-model="order.order_type"
          :items="choices.order_type"
          label="Тип пропуска"
          outlined
          class="mt-4"
          :readonly="edit"
          :disabled="edit"
          :error="hasError('order_type')"
          :errorMessages="getError('order_type')"
      >
        <template v-slot:label>
          Тип пропуска <strong class="red--text">*</strong>
        </template>
      </v-autocomplete>
      <div v-if="order.order_type !==7">
        <!-- Блок отображения ответственного заявки по умолчанию -->
        <v-row no-gutters class="text-left pb-6" v-if="!edit_responsible">
          <v-col cols="11" class="text--secondary"
                 style="border: rgb(0, 0, 0, 50%) 1px solid; border-radius: 5px; padding: 16px 12px">
            <strong>Ответственный: </strong>
            <span v-if="edit">{{ order_responsible }}</span>
            <span v-else>Вы будете назначены ответственным по умолчанию</span>
          </v-col>
          <v-col cols="1" class="mt-5 mt-sm-2 pl-sm-4">
            <v-btn
                fab
                icon
                small
                color="primary"
                @click="() => {this.edit_responsible = true; this.order.responsible = ''}"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                      v-bind="attrs"
                      v-on="on"
                  >
                    close
                  </v-icon>
                </template>
                <span>Изменить ответственного</span>
              </v-tooltip>
            </v-btn>
          </v-col>
        </v-row>
        <!-- Блок выбора ответственного заявки -->
        <loading-autocomplete
            v-if="edit_responsible"
            placeholder="Введите ФИО и выберете из предложенных вариантов"
            label="Ответственный"
            v-model="order.responsible"
            search-parameter="search"
            :load-fios="false"
            outlined
            :url="subordinates_selector"
            :error="hasError('responsible')"
            :errorMessages="getError('responsible')"
        >
          <template v-slot:no-data>
            <div>
              Для поиска начните набирать ФИО, <br> и подождите 1 секунду, либо нажмите Enter
            </div>
          </template>
        </loading-autocomplete>
        <!-- Блок даты заявки для поятоянных заявок -->
        <v-row v-if="order.order_type === 5 || order.order_type === 2 || order.order_type === 3" no-gutters>
          <v-col cols="12" sm="6">
            <date-picker
                class="mr-md-3"
                key="start_date"
                v-model="order.start_date"
                label="Дата начала"
                :allowed-dates="disablePastDates"
                :required="true"
                outlined
                prepend-outer-icon
                icon="calendar_month"
                :error="hasError('start_date')"
                :errorMessages="replaceErrorDateText(getError('start_date'))"
            ></date-picker>
          </v-col>
          <v-col cols="12" sm="6">
            <date-picker
                key="end_date"
                v-model="order.end_date"
                label="Дата окончания"
                :allowed-dates="disableFutureDates"
                :required="true"
                outlined
                prepend-outer-icon
                icon="calendar_month"
                :date-static-lower="order.start_date"
                :error="hasError('end_date')"
                :errorMessages="replaceErrorDateText(getError('end_date'))"
            ></date-picker>
          </v-col>
        </v-row>
        <!-- Блок даты заявки для разовых заявок -->
        <v-row v-else no-gutters>
          <v-col cols="12">
            <date-picker
                key="end_date"
                v-model="order.start_date"
                label="Дата прохода"
                :required="true"
                outlined
                prepend-outer-icon
                icon="calendar_month"
                :allowed-dates="disablePastDates"
                :error="hasError('start_date')"
                :errorMessages="replaceErrorDateText(getError('start_date'))"
            ></date-picker>
          </v-col>
        </v-row>
        <!-- Блок организации заявки -->
        <v-autocomplete
            v-model="order.organization"
            :items="selectors.organizations"
            label="Организация"
            outlined
            readonly
            disabled
            :error="hasError('organization')"
            :errorMessages="getError('organization')"
        >
          <template v-slot:label>
            Организация <strong class="red--text">*</strong>
          </template>
        </v-autocomplete>
<!--        <v-checkbox-->
<!--            v-model="cookie_organization.check"-->
<!--            @click="saveOrganizationToCookie(order.organization)"-->
<!--            class="mt-0 mb-3"-->
<!--            label="Запомнить организацию по умолчанию"-->
<!--        ></v-checkbox>-->
        <!-- Блок территории заявки -->
        <v-autocomplete
            v-model="order.territory"
            :items="selectors.territories"
            label="Территория"
            outlined
            item-value="uid"
            item-text="name"
            :error="hasError('territory')"
            :errorMessages="getError('territory')"
        >
          <template v-slot:label>
            Территория <strong class="red--text">*</strong>
          </template>
        </v-autocomplete>
        <!-- Блок здания заявки -->
        <v-autocomplete
            v-model="order.building"
            :items="selectors.buildings"
            label="Адрес"
            item-value="uid"
            :disabled="!Boolean(order.territory)"
            outlined
            item-text="name"
            :error="hasError('building')"
            :errorMessages="getError('building')"
        >
          <template v-slot:label>
            Адрес <strong class="red--text">*</strong>
          </template>
        </v-autocomplete>
        <!-- Блок помещения заявки -->
        <!--      <v-autocomplete-->
        <!--          v-model="order.room"-->
        <!--          :items="selectors.rooms"-->
        <!--          label="Помещение"-->
        <!--          :error="hasError('room')"-->
        <!--          :errorMessages="getError('room')"-->
        <!--      ></v-autocomplete>-->
        <v-text-field
            v-model="order.room"
            label="Помещение"
            outlined
            :error="hasError('room')"
            :errorMessages="getError('room')"
        ></v-text-field>
        <!-- Блок причины заявки -->
        <v-autocomplete
            :items="choices.purpose"
            v-model="order.purpose"
            label="Цель посещения"
            outlined
            :error="hasError('purpose')"
            :error-messages="getError('purpose')"
        >
          <template v-slot:label>
            Цель посещения <strong class="red--text">*</strong>
          </template>
        </v-autocomplete>
        <!-- Блок добавления автомобиля для Автомобильной заявки -->
        <v-text-field
            v-if="order.order_type === 5 "
            v-model="order.justification"
            label="Обоснование"
            outlined
            :error="hasError('justification')"
            :errorMessages="getError('justification')"
        ></v-text-field>
        <div v-if="order.order_type === 5 ">
          <v-row justify="space-between" align="center" v-if="edit && order.attached_file && !order.attached_file?.name" no-gutters class="border-md rounded mb-2">
            <v-col cols="auto" class="pa-4">
              Файл: <a target="_blank" :href="order.attached_file">{{order.file_name}}</a>
            </v-col>
            <v-col cols="auto">
              <v-tooltip location="bottom" text="Заменить файл">
                <template v-slot:activator="{ props }">
                  <v-icon v-bind="props" class="mr-4 opacity-60" @click="order.attached_file = undefined">cancel</v-icon>
                </template>
              </v-tooltip>
            </v-col>
          </v-row>
          <v-file-input
              v-else
              v-model="order.attached_file"
              label="Файл"
              outlined
              :multiple="false"
              :error="hasError('attached_file')"
              :error-messages="getUpdateError(getError('attached_file'))"
          >
          </v-file-input>
        </div>
        <v-autocomplete
            ref="cars-autocomplete"
            v-if="order.order_type === 4 && !add_car || order.order_type === 5 && !add_car"
            v-model="order.car"
            :items="selectors.cars"
            label="Автомобиль"
            outlined
            :error="hasError('car')"
            :error-messages="getError('car')"
        >
          <template v-slot:label>
            Автомобиль <strong class="red--text">*</strong>
          </template>
          <template v-slot:prepend-item>
            <v-btn
                block
                elevation="0"
                text
                @click="addNewCar"
            >
              <v-icon>add</v-icon>
              Добавить новый автомобиль
            </v-btn>
          </template>
        </v-autocomplete>
        <!-- Блок добавления нового автомобиля -->
        <v-card
            v-if="add_car"
            class="pa-4 pb-0 mb-5"
            color="grey lighten-3"
        >
          <v-card-title class="pa-0">
            Добавление автомобиля:
            <v-spacer></v-spacer>
            <v-btn
                fab
                icon
                small
                @click="closeAddCar"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-row no-gutters class="pa-0 pt-4">
            <v-col cols="12" md="6" class="pr-md-1">
              <v-text-field
                  ref="new-car-number"
                  v-model="create_car.number"
                  label="Номер"
                  outlined
                  :error="hasError('car.number')"
                  :error-messages="getError('car.number')"
              >
                <template v-slot:label>
                  Номер <strong class="red--text">*</strong>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" md="6" class="pr-md-1">
              <loading-autocomplete
                  placeholder="Введите название и выберете из предложенных вариантов"
                  label="Марка"
                  outlined
                  required
                  v-model="create_car.model"
                  search-parameter="search"
                  :url="car_selector"
                  :error="hasError('car.model')"
                  :error-messages="getError('car.model')"
                  :item-text="getText"
                  :load-fios="false"
              >
                <template v-slot:no-data>
                  <div class="px-4">
                    Для поиска начните набирать название, <br> и подождите 1 секунду, либо нажмите Enter
                  </div>
                </template>
              </loading-autocomplete>
            </v-col>
            <v-alert v-if="hasError('car.car') && create_car.number && create_car.model" type="error">
              {{ getError('car.car')[0] }}
            </v-alert>
          </v-row>
        </v-card>
        <!-- Блок добавления посетителя заявки -->
        <template v-if="order.order_type !== 6">
          <template
              v-for="(item,i) in order_visitors"
          >
            <OrderVisitors
                :key="i+'visitor'"
                :item="item"
                :index="i"
                :organizations="organizations_selector"
                :visitors="selectors.visitors"
                :user_selector="user_selector"
                :add-visitor.sync="add_visitors"
                :order-visitors.sync="order_visitors"
                :special-error.sync="special_error"
                :visitor_error="visitor_error"
                :order-type="order.order_type"
                :is_copy="order.copy"
            >
            </OrderVisitors>
          </template>
        </template>
        <v-row no-gutters v-if="order.order_type === 3">
          <v-spacer></v-spacer>
          <v-btn
              text
              @click="addNewVisitor"
              class="pr-0 mt-1"
          >
            Добавить еще одного посетителя
            <v-icon>add</v-icon>
          </v-btn>
        </v-row>
      </div>

      <div v-else>
        <v-alert class="mt-4 rounded-lg" type="info" outlined>
          <p class="subtitle-1"><b>Уважаемый пользователь!</b></p>
          <p class="text-left">Уведомляем Вас, что для получения <b>постоянного автомобильного пропуска</b>, необходимо
            предоставить служебную записку в Службу безопасности Университета.</p>
          <p class="text-left">Служебная записка может быть предоставлена в бумажном формате в кабинет №131 Миусского
            комплекса или в электронном формате с использованием Системы электронного документооборота (СЭД).</p>
        </v-alert>
      </div>
    </div>

    <div class="action mt-8 mb-4 align-center" v-else>
      <semipolar-spinner
          class="d-inline-block"
          :animation-duration="2000"
          :size="115"
          color="#1935ff"
      />
    </div>
    <v-alert outlined rounded :icon="'priority_high'" v-if="hasError('non_field_errors') " type="error">
      {{ getError('non_field_errors')[0] }}
    </v-alert>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import DatePicker from "@/modules/core/components/DatePicker.vue";
import selectors from "@/urls/selectors";
import LoadingAutocomplete from "@/modules/core/components/LoadingAutocomplete";
import {SemipolarSpinner} from "epic-spinners";
import OrderVisitors from "@/modules/templates/OrderVisitors";
import guard_names from "@/modules/guard/routers/names";

export default {
  name: "RepresentativeEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    orderData: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    ScrollCenterDialog,
    DatePicker,
    SemipolarSpinner,
    LoadingAutocomplete,
    OrderVisitors
  },
  data() {
    return {
      loading: false,
      order_default: {
        start_date: "",
        end_date: "",
        order_type: 1,
        organization: 'a4985abb-6fe5-4b32-a543-f0b006669314',
        territory: null,
        building: null,
        room: "",
        purpose: null,
        car: undefined,
        visitors: undefined,
        additional_info: []
      },
      cookie_organization: {
        check: false
      },
      add_car: false,
      edit_responsible: false,
      save_loading: false,
      order_responsible: "",
      create_car: {
        number: "",
        model: ""
      },
      add_visitors: [
        {
          visitor: false,
          portal_user: false
        }
      ],
      order_visitors: [
        {visitor_id: undefined}
      ],
      order: undefined,
      choices: {
        order_type: [],
        purpose: []
      },
      selectors: {
        organizations: [],
        territories: [],
        buildings: [],
        rooms: [],
        cars: [],
        visitors: [],
        models: []
      },
      special_error: [],
      visitor_error: []
    }
  },
  watch: {
    // Очистка полей при смене типа заявки
    "order.order_type"() {
      this.order.car = undefined
      this.order.visitors = undefined
      this.add_car = false
      this.add_visitors.visitor = false
      this.add_visitors.portal_user = false
      this.create_car = {
        number: "",
        model: ""
      }
      this.order_visitors = [{visitor_id: undefined}]
      // При редактировании заявки, чтобы не очищалось поле даты конца
      if (!this.edit) {
        if (this.order.order_type === 3 || this.order.order_type === 5 || this.order.order_type === 2) {
          this.order.end_date = ""
        } else {
          this.order.end_date = this.order.start_date
        }
      }
    },
    "order.start_date"() {
      if (this.order.order_type === 1 || this.order.order_type === 6 || this.order.order_type === 4) {
        this.order.end_date = this.order.start_date
      }
    },
    // order: {
    // handler: function() {
    //   this.errors = {
    //     fields: {},
    //     non: []
    //   }
    // },
    // deep: true
    // },
    order_visitors: {
      handler: function () {
        this.special_error = []
      },
      deep: true
    },
    "order.organization"() {
      this.loadTerritoriesSelector({
        url: undefined,
        gets: {organization: this.order.organization},
        finalizer: (val) => {
          if (this.selectors.territories.length > 0 && this.selectors.territories !== val) {
            this.order.territory = null
          }
          this.selectors.territories = val
        }
      })
    },
    "order.territory"() {
      this.order.building = null
      if (this.order.territory)
        this.loadBuildingsSelector({
          url: undefined,
          gets: {territory: this.order.territory},
          finalizer: (val) => {
            this.selectors.buildings = val
          }
        })
    }
  },
  computed: {
    form_title() {
      return this.edit === false ? "Добавить заявку" : "Редактировать заявку"
    },
    user_selector() {
      return selectors.SELECTORS.USERS.ALL()
    },
    subordinates_selector() {
      return selectors.SELECTORS.ORDERS.SUBORDINATES()
    },
    organizations_selector() {
      return selectors.SELECTORS.VISITORS.ORGANIZATIONS()
    },
    car_selector() {
      return selectors.SELECTORS.CARS.MODELS()
    }
  },
  methods: {
    ...mapActions({
      createOrder: "representative/createOrders",
      changeOrder: "representative/changeOrders",
      loadUserOrganization: "representative/loadUserOrganization",
      loadOrderDetail: "representative/loadOrdersDetail",
      loadOrderTypeChoices: "choices/loadOrderTypeChoices",
      loadPurposeChoices: "choices/loadPurposeChoices",
      loadOrganizationSelector: "selectors/loadOrganizationSelector",
      loadTerritoriesSelector: "selectors/loadTerritoriesSelector",
      loadBuildingsSelector: "selectors/loadBuildingsSelector",
      loadRoomsSelector: "selectors/loadRoomsSelector",
      loadCarsSelector: "selectors/loadCarsSelector",
      loadUsersVisitorsSelector: "selectors/loadUsersVisitorsSelector",
      loadCarsModelsSelector: "selectors/loadCarsModelsSelector",
      loadOrganizationsSelector: "selectors/loadOrganizationsSelector"
    }),
    getUpdateError(errText){
      if (!errText)
        return errText
      if (String(errText).includes('Формат файла')) {
        return 'Допустимый формат файла - pdf'
      }
      return errText
    },
    close() {
      this.$emit("close", false)
    },
    loadUserInfo() {
      if (window.$cookies.get("cookie_organization")) {
        this.cookie_organization.check = true
        this.order.organization = window.$cookies.get("cookie_organization")
      } else {
        this.loadUserOrganization({
          url: undefined,
          finalizer: (val) => {
            this.order.organization = val?.uid
          }
        })
      }
    },
    loadSelectors() {
      this.loadOrganizationSelector({
        url: undefined,
        finalizer: (val) => {
          this.selectors.organizations = val
        }
      })
      // this.loadRoomsSelector({
      //   url: undefined,
      //   finalizer: (val) => {
      //     this.selectors.rooms = val
      //   }
      // })
      this.loadCarsSelector({
        url: undefined,
        finalizer: (val) => {
          this.selectors.cars = val
        }
      })
      this.loadUsersVisitorsSelector({
        url: undefined,
        finalizer: (val) => {
          this.selectors.visitors = val
        }
      })
      this.loadCarsModelsSelector({
        url: undefined,
        finalizer: (val) => {
          this.selectors.models = val
        }
      })
    },
    loadChoices() {
      this.loadOrderTypeChoices({
        url: undefined,
        finalizer: (val) => {
          this.choices.order_type = val
          this.choices.order_type.push({value: 7, text: "Постоянный автомобильный пропуск"})
          if (!this.edit) {
            this.choices.order_type[0].text = "Разовый (Не требует согласования)"
            this.choices.order_type[3].text = "Автомобильный разовый (Не требует согласования)"
          }
          if (this.edit) {
            this.order.order_type = this.choicesTextToValue(this.order.order_type, "order_type")
          }
        }
      })
      this.loadPurposeChoices({
        url: undefined,
        finalizer: (val) => {
          this.choices.purpose = val
          if (this.edit) {
            this.order.purpose = this.choicesTextToValue(this.order.purpose, "purpose")
          }
        }
      })
    },
    getText(value) {
      if (value !== undefined)
        return `${value.text}`
      else
        return ""
    },
    saveOrganizationToCookie(value) {
      if (this.cookie_organization.check) {
        window.$cookies.set("cookie_organization", value)
      } else {
        if (window.$cookies.get("cookie_organization")) {
          window.$cookies.remove("cookie_organization")
        }
      }
    },
    loadOrderData() {
      if (this.orderData === undefined) {
        this.order_default.start_date = new Date().toISOString().split("T")[0];
        this.order = this.order_default
        this.loading = true
      } else {
        this.order = JSON.parse(JSON.stringify(this.orderData))
        this.order.organization = this.orderData.organization.uid
        this.order.territory = this.orderData.territory.uid
        // this.order.room = this.orderData.room.uid
        this.order_responsible = this.orderData.responsible.fio
        this.order.responsible = this.orderData.responsible.uid
        // Загрузка данных при редактировании из детальки, чтобы получить авто и посетителей
        this.loadOrderDetail({
          url: undefined,
          id: this.orderData.id,
          finalizer: (data) => {
            // Получение данных о Территории
            this.order.territory = data.territory.uid
            // Получение данных об Адресе
            this.order.building = data.building.uid
            // Преобразование авто перед выводом в форме
            if (this.order.order_type === 4 || this.order.order_type === 5) {
              this.order.car = data.car.id
            }
            // Преобразование посетителей перед выводом в форме
            if (this.order.order_type !== 6 && data.visitors.length > 0) {
              this.order_visitors = []
              this.add_visitors = []
              for (let item in data.visitors) {
                this.order_visitors.push(data.visitors[item])
                if (this.order.is_copy) {
                  this.add_visitors.push({visitor: true, portal_user: false, is_copy: true})
                } else {
                  this.add_visitors.push({visitor: true, portal_user: false, is_copy: false})
                }
              }
            }
            this.loading = true
          }
        })
      }
    },
    save() {
      this.save_loading = true
      // Преобразования автомобиля перед отправкой данных
      if (this.order.order_type === 4 || this.order.order_type === 5) {
        if (this.add_car) {
          this.order.car = this.create_car
        } else {
          if (this.order.car !== undefined && typeof this.order.car === "number") {
            let id = this.order.car
            this.order.car = {id: id}
          }
        }
      }
      // Преобразования списка посетителей перед отправкой данных
      // Проверка на пустоту, проверка на пустое значение
      if (this.order_visitors.length > 0) {
        // Присваиваем значения исходных массивов временным
        let tempArrayAddVisitor = []
        let tempArrayVisitor = this.order_visitors
        // Фильтруем массив посетителей от пустых полей
        this.order_visitors = this.order_visitors.filter(item => Object.keys(item).length)
        this.order_visitors = this.order_visitors.filter(item => item.user || item.visitor_id || item.last_name)
        // Сравниваем исходных с отфильтрованным массивом и фильтруем массив булей
        for (let i in tempArrayVisitor) {
          for (let j in this.order_visitors) {
            if (tempArrayVisitor[i] === this.order_visitors[j]) {
              tempArrayAddVisitor.push(this.add_visitors[i])
            }
          }
        }
        this.add_visitors = tempArrayAddVisitor
        // Кладем данные, который идут на отправку
        this.order.visitors = this.order_visitors
        // Если после фильтрации наш массив остался пустой, то возвращаем его в исходное состояние
        if (this.order_visitors.length === 0) {
          this.order_visitors = [{visitor_id: undefined}]
          this.add_visitors = [{
            visitor: false,
            portal_user: false,
            is_copy: false
          }]
        }
      }
      let formData = new FormData()
      for(let key in this.order) {
        if(this.order[key] )
          if (key==="attached_file"){
            if(typeof this.order[key] === "object") {
              formData.append(key, this.order[key])
            }
          }
          else if  (key==="visitors" || key==="car")
            formData.append(key, JSON.stringify(this.order[key]))
          else
            formData.append(key, this.order[key])
      }
      if (this.edit) {
        // Поле обязательное, но его пока нет
        this.order.additional_info = []
        this.changeOrder({
          data: formData,
          finalizer: () => {
            this.$emit("close", this.order)
            this.save_loading = false
          },
          catcher: (val) => {
            if (val.visitor) {
              this.visitor_error = val.visitor
            } else if (!val.visitors) {
              this.mapErrors(val)
            } else {
              this.special_error = val.visitors
            }
            if (Error.isError(val)) {
              val.non_field_errors = ['Ваш файл не должен превышать 15МБ']
            }
            this.save_loading = false
          }
        })
      } else {
        this.createOrder({
          data: formData,
          finalizer: (val) => {
            this.order.id = val.id
            this.$emit("close", this.order)
            this.save_loading = false
          },
          catcher: (val) => {
            if (val.visitor) {
              this.visitor_error = val.visitor
            } else if (!val.visitors) {
              this.mapErrors(val)
            } else {
              this.special_error = val.visitors
            }
            if (Error.isError(val)) {
              val.non_field_errors = ['Ваш файл не должен превышать 15МБ']
            }
            this.save_loading = false
          }
        })
      }
    },
    // Определения значения при редактировании
    choicesTextToValue(text, choices) {
      let typeValue = this.choices[choices].find(
          item => {
            if (item.text === text) {
              return item
            }
          }
      )
      if (typeValue) {
        return typeValue.value
      }
      return null
    },
    // Создания нового авто
    addNewCar() {
      this.add_car = true
      this.$nextTick(() => {
        this.$refs["new-car-number"].focus();
        this.$refs["new-car-number"].inputMode;
      })
    },
    closeAddCar() {
      this.add_car = false
      this.create_car = {
        number: "",
        model: ""
      }
      this.$nextTick(() => {
        this.$refs["cars-autocomplete"].focus();
        this.$refs["cars-autocomplete"].isMenuActive = true;
      })
    },
    // Добавление еще одного поля создания нового посетителя
    addNewVisitor() {
      this.order_visitors.push({})
      this.add_visitors.push({
        visitor: false,
        portal_user: false
      })
    },
    replaceErrorDateText(text) {
      if (typeof text === "object" && text !== null) {
        let tempString = text[0].replace("YYYY-MM-DD", "ДД.ММ.ГГГГ")
        tempString = tempString.replace("date", "даты")
        return [tempString]
      }
      return null
    },
    disablePastDates(val) {
      return val >= new Date().toISOString().split("T")[0]
    },
    disableFutureDates(val) {
      let limit = this.order.order_type === 5 ? 90 : 30
      let date = new Date(new Date(this.order.start_date).setDate(new Date(this.order.start_date).getDate() + limit))
      return val <= date.toISOString().split("T")[0]
    }
  },
  created() {
    this.loadOrderData()
    this.loadChoices()
    this.loadSelectors()
    if (!this.edit) {
      this.loadUserInfo()
    }
  }
}
</script>

<style scoped>

</style>
